import {BaseLinkParams} from "./base-link-params";

export class EntityLinkParams extends BaseLinkParams {
  id: Number;
  sportName: String;
  filter: String;

  constructor(id: Number, sportName: String, filter: String) {
    super();

    this.id = id;
    this.sportName = sportName;
    this.filter = filter;
  }
}
